module.exports = __webpack_public_path__ + "img/logo-light.ab0d95ed.svg";